<div *ngIf="showLoading" class="loading-gif">
  <figure>
    <img src="./../../../../assets/images/icons/loader.svg" class="loader">
  </figure>
</div>
